import api from '../api';
import { LoadConfig } from 'utils/loadConfig';

import { ParamsBodyAuthentication } from 'utils/typeServices';

export const PostAuthentication = async ({ usuario, password }: ParamsBodyAuthentication) => {
    const bodyJson = JSON.stringify({ usuario, password });

    try {
        const { data } = await api.post('v2/Autenticacao', bodyJson);

        return { data: JSON.parse(data) };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}

export const PostAuthenticationClientCredentials = async () => {
    const scope = 'customerArea_scope';
    const keySecret = LoadConfig().REACT_APP_KEY_SECRET;

    try {
        const { data } = await api.post<{ access_token: string, expires_in: number; }>(`v2/Autenticacao/clientcredentials?chave=${keySecret}&scope=${scope}`);

        return { data: data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
